var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid gap-8",class:`grid-cols-${_vm.component.columns_mobile ?? 2} md:grid-cols-${_vm.component.columns ?? 1}`},_vm._l((_vm.products),function(product){return _c('ProductCard',{key:product.id,attrs:{"product":product}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }